
const useFunctions = () => {

    return {
        toCamelCase: (str) => {
            str = str.replace(/([^\s]+)/g, function(w) {
                return w[0].toUpperCase() + w.slice(1).toLowerCase();
            });
            return str;
        },
        ValidateEmail: (text) => {
            var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (text.match(validRegex)) {
                return true;
            } else {
                return false;
            }
        },
        addDays: (date, days) => {
            let result = new Date(date)
            result.setDate(result.getDate() + days)
            return result
        },
        deleteDifferenceTimezone: (date) => {
            return new Date(date.setMinutes(date.getMinutes() + date.getTimezoneOffset()))
        },
        checkTokenExpiration: () => {
            const expirationTime = localStorage.getItem('expirationTime');
            return expirationTime && new Date().getTime() > expirationTime;
        },
        calculateExpirationTime: () => {
            return new Date().getTime() + 60 * 60 * 1000;
        },
        verifyRol: (currentUser, role) => {
            return currentUser.roles.filter(r => r.id == role).length > 0
        },
        formatCOP: (amount) => {
            if (isNaN(amount)) {
                return "Valor no válido";
            }
            
            return amount.toLocaleString('es-CO', {
                style: 'currency',
                currency: 'COP',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });
        }
    }

}

export default useFunctions